import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AuthPage from '../pages/auth';

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AuthPage />} />
    </Routes>
  );
};

export default AuthRoutes;
